import { render } from "./baidu-image-spider.vue?vue&type=template&id=29feb3f3&ts=true"
import script from "./baidu-image-spider.vue?vue&type=script&lang=ts"
export * from "./baidu-image-spider.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__